import { render } from "./HotelDetailDialog.vue?vue&type=template&id=c5b6dc96"
import script from "./HotelDetailDialog.vue?vue&type=script&lang=js"
export * from "./HotelDetailDialog.vue?vue&type=script&lang=js"

import "./HotelDetailDialog.vue?vue&type=style&index=0&id=c5b6dc96&lang=scss"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__